module.exports = __webpack_public_path__ + "img/pcScreen_b.3b31a6fc.svg";